import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { useAuthSessionStore } from '@/features/auth/stores/auth-session-store'
import { SiteHeader } from './site-header'
import { SiteFooter } from './site-footer'
import './marketing-colors.css'

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="public-site min-h-screen bg-white text-[#101727] select-text [--background:#ffffff] [--foreground:#101727] [--card:#ffffff] [--card-foreground:#101727] [--muted:#f5f6f8] [--muted-foreground:#697184] [--accent:#eff9eb] [--accent-foreground:#183118] [--border:#e5e7eb] [--primary:#3f9437] [--primary-foreground:#ffffff]">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  )
}

/** Gradient text helper for marketing headlines */
export function GradientText({ children }: { children: ReactNode }) {
  return (
    <span className="bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent">
      {children}
    </span>
  )
}

/** Reusable CTA that respects the existing cookie-backed auth session. */
export function AppCtaLink({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const session = useAuthSessionStore((state) => state.session)
  return (
    <Link
      to={session ? '/app' : '/register'}
      className={
        'inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 ' +
        (className ?? '')
      }
    >
      {children}
    </Link>
  )
}
